import { getMailboxCreationDateTimestampInDays } from './getMailboxCreationDateTimestampInDays';

/**
 * @description Returns the iteration count to be shown to the user based on account creation date
 *
 * To add a new iteration, select the sign up date.
 *  The users who have signed up post the date will see the newer iteration.
 * Find the UTC epoch time for the date, and convert it to number of days. Add the value in the array with a comment denoting the date.
 */
export const getCampaignIterationCount = (): number => {
    const mailboxCreationDateTimestampInDays = getMailboxCreationDateTimestampInDays();
    const iterationMap = [
        19130, //18th May 2022, UTC
        19206, //2nd August 2022, UTC
    ];

    let iterationCount = 0;

    for (let index = iterationMap.length - 1; index >= 0; index--) {
        if (mailboxCreationDateTimestampInDays >= iterationMap[index]) {
            iterationCount = index + 1;
            break;
        }
    }

    return iterationCount;
};
